export const industries = [
  {
    icon: 'utensils',
    name: 'Restaurants',
    description: 'Full-service, fast casual, and independent operators.',
  },
  {
    icon: 'hotel',
    name: 'Hotels',
    description: 'Food and beverage programs inside hospitality properties.',
  },
  {
    icon: 'concierge',
    name: 'Hospitality',
    description: 'Venues, catering, and event-driven service businesses.',
  },
  {
    icon: 'shopping',
    name: 'Retail',
    description: 'Inventory-heavy retail with tight margin requirements.',
  },
  {
    icon: 'factory',
    name: 'Food Manufacturing',
    description: 'Production costing, yield tracking, and supplier control.',
  },
  {
    icon: 'network',
    name: 'Franchises',
    description: 'Brand standards and unit-level performance benchmarking.',
  },
  {
    icon: 'building',
    name: 'Multi-unit Operations',
    description: 'Consolidated reporting across every location you run.',
  },
  {
    icon: 'heart',
    name: 'Nonprofits',
    description: 'Stewardship of budgets, grants, and food programs.',
  },
  {
    icon: 'landmark',
    name: 'Government Food Service',
    description: 'Compliance-ready reporting and procurement oversight.',
  },
]
